export function formatBoolean(
    value: boolean,
    translate?: (key: string) => string
): string {
    if (translate) {
        return value
            ? translate('preview.common.yes')
            : translate('preview.common.no');
    }
    return value ? 'Yes' : 'No';
}

export function formatArray(value: unknown[]): string {
    return value.join(', ');
}

export function resolveDataSourceLabel(
    value: unknown,
    options: unknown[]
): string | null {
    if (
        options.length === 0 ||
        typeof options[0] !== 'object' ||
        options[0] === null
    ) {
        return null;
    }

    const matchingOption = options.find((option) => {
        if (typeof option !== 'object' || option === null) return false;
        const record = option as Record<string, unknown>;
        return (
            record.value === value ||
            record.id === value ||
            record._id === value
        );
    }) as Record<string, unknown> | undefined;

    if (!matchingOption) return null;
    const label = matchingOption.label || matchingOption.name;
    return typeof label === 'string' ? label : null;
}
